var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-view-view"},[_c('MainWrapper',{attrs:{"element":_vm.activeView,"is-view":true}}),_vm._v(" "),_c('MainModals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }